import isChoiceNature from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/Helpers/isChoiceNature';

type OptionsShape = { readonly nature: string };

/** A choice field needs at least one option; any other nature needs none. */
function hasOptionsForChoice<T extends OptionsShape>(value: readonly unknown[], formData: T): boolean {
	return !isChoiceNature(formData.nature) || value.length > 0;
}

export default hasOptionsForChoice;
